import moment from 'moment';

import templateUrl from './edit-payout-policy-history.component.html'

export const EditPayoutPolicyHistoryComponent = {
    controller: EditPayoutPolicyHistoryController,
    controllerAs: "vm",
    templateUrl,
    require: {
        editForm: "^form"
    },
    bindings: {
        payoutPolicyHistory: "<",
        deleteHistoryItem: "&onDeleteHistoryItem",
        addHistoryItem: "&onAddHistoryItem"
    }
};

function EditPayoutPolicyHistoryController() {
    const vm = this;

    vm.editForm;
    vm.validate = validate;
    vm.onChangePayoutPolicyDate = onChangePayoutPolicyDate;

    vm.$onInit = function () {
        // Initial validation.
        validate();
    }

    function onChangePayoutPolicyDate(policy) {
        updatePayoutPolicyHistory(vm.payoutPolicyHistory, policy)
        validate();
    }

    function updatePayoutPolicyHistory(payoutPolicyHistory, currentPolicy) {

        const nextPolicy = payoutPolicyHistory.reduce(function (nextPolicy, other) {
            if (other === currentPolicy || moment(other.ActiveStart).isSameOrBefore(currentPolicy.ActiveStart)) {
                return nextPolicy
            }

            if (!nextPolicy || moment(nextPolicy.ActiveStart).isSameOrAfter(other.ActiveStart)) {
                return other;
            } else {
                return nextPolicy;
            }
        }, null);
        if (nextPolicy && !currentPolicy.ActiveEnd) {
            currentPolicy.ActiveEnd = moment(nextPolicy.ActiveStart).subtract(1, "day").toDate();
        }

        const previousPolicy = payoutPolicyHistory.reduce(function (previousPolicy, other) {
            if (other === currentPolicy || moment(other.ActiveStart).isSameOrAfter(currentPolicy.ActiveStart)) {
                return previousPolicy
            }

            if (!previousPolicy || moment(previousPolicy.ActiveStart).isSameOrBefore(other.ActiveStart)) {
                return other;
            } else {
                return previousPolicy;
            }
        }, null);

        if (previousPolicy && !previousPolicy.ActiveEnd) {
            previousPolicy.ActiveEnd = moment(currentPolicy.ActiveStart).subtract(1, "day").toDate();
        }
    }

    function validate() {
        // Keep the dates organized in descending order.
        vm.payoutPolicyHistory.sort(function (a, b) {
            if (a.ActiveStart > b.ActiveStart) {
                return -1;
            }
            if (a.ActiveStart < b.ActiveStart) {
                return 1;
            }
            return 0;
        });

        const isValidHistoryOrder = vm.payoutPolicyHistory.reduce(function (ag, policy, i, a) {
            if (!ag.valid) {
                return ag;
            }

            const valid = !(
                policy.ActiveStart && policy.ActiveEnd && policy.ActiveStart > policy.ActiveEnd // Doesn't end before it starts.
                || !policy.ActiveEnd && i !== 0 // Doesn't omit start date unless it's the first entry.
                || !policy.ActiveStart && i !== a.length - 1 // Doesn't omit end date unless it's the last entry.
                || ag.previousStart && policy.ActiveEnd >= ag.previousStart); // Doesn't overlap with a previous entry (in descending order)

            return {
                previousStart: policy.ActiveStart,
                previousEnd: policy.ActiveEnd,
                valid: valid
            };
        }, { previousStart: null, previousEnd: null, valid: true }).valid;

        if (vm.editForm) {
            vm.editForm.$setValidity("historyOrder", isValidHistoryOrder);
        }

        return isValidHistoryOrder;
    }
}
